import { render, staticRenderFns } from "./GsmNumber.vue?vue&type=template&id=1a486340&"
import script from "./GsmNumber.vue?vue&type=script&lang=ts&"
export * from "./GsmNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports